import { render } from "./SupplierComponent.vue?vue&type=template&id=16496141&scoped=true"
import script from "./SupplierComponent.vue?vue&type=script&lang=js"
export * from "./SupplierComponent.vue?vue&type=script&lang=js"

import "./SupplierComponent.vue?vue&type=style&index=0&id=16496141&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16496141"]])

export default __exports__